import { BACK_VERSION_PARAM, FRONT_VERSION_PARAM } from '../constants';
import { addQueryParamsToUrl } from './addQueryParamsToUrl';
import { getParameterByName } from './getParameterByName';

const VERSION_PARAMS = [FRONT_VERSION_PARAM, BACK_VERSION_PARAM] as const;

/**
 * Adds the front version and back version query params to a given URL if the
 * URL does not have them already. This should be used only if the URLs are generated
 * on the backend side, if the URL are created on the frontend side, using @lumapps/router
 * should do the trick.
 *
 * @param url
 * @returns url with front/back version query params
 */
export const addCustomVersionParamsToUrl = (url: string) => {
    let result = url;
    for (const param of VERSION_PARAMS) {
        const currentValue = getParameterByName(param);
        if (currentValue && !getParameterByName(param, url)) {
            result = addQueryParamsToUrl(result, { [param]: currentValue }, false);
        }
    }
    return result;
};
